const BASE_URL = `${__API_URL__}flightDelay`;
const SUGGESTIONS_LIMIT = 8;
const fetchSuggestions = async (endpoint, query = '') => {
    try {
        const url = new URL(`${BASE_URL}/${endpoint}`);
        if (query.trim()) {
            url.searchParams.append('search', query.trim());
        }
        url.searchParams.append('limit', String(SUGGESTIONS_LIMIT));
        const response = await fetch(url.toString(), {
            headers: { accept: 'application/json' },
        });
        if (!response.ok) {
            throw new Error(`Failed to fetch: ${response.statusText}`);
        }
        const data = await response.json();
        return data.slice(0, SUGGESTIONS_LIMIT);
    }
    catch (error) {
        console.error(error);
        return [];
    }
};
export const getAirlineSuggestions = async (query) => {
    const airlines = await fetchSuggestions('airlines', query);
    return airlines.map(({ name, iata }) => ({ name, code: iata }));
};
export const getAirportSuggestions = async (query) => {
    const airports = await fetchSuggestions('airports', query);
    return airports.map(({ name, iata, cityName }) => ({
        name,
        code: iata,
        cityName,
    }));
};
